module.exports = __webpack_public_path__ + "img/labmemtest_title_en.45d9574e.png";